<template>
  <div :class="['auth-wrapper', captchaPatten]">
    <div class="auth-header">
      <div class="auth-title">
        <span
          class="auth-avator"
          :style="{background: shareInfo.profileColor}"
        >{{ getAvatorName }}</span><!--
                --><span class="user-name">{{ shareInfo.userName }}</span><span class="user-name-tail">{{ $t('给您分享了一个文件') }}</span>
      </div>
      <div class="auth-description">
        <span class="main-des">{{ needCaptchaAuth? $t('请输入邮箱/手机号和验证码后查看文件：') : $t('请输入邮箱/手机号后查看文件：') }}</span><br>
        <span class="sub-des">{{ $t('您的信息仅对分享人可见，不会被泄漏，请放心填写') }}</span>
      </div>
    </div>
    <div class="auth-body">
      <!--中国手机号 或 通用email-->
      <div
        v-if="!isShowInt"
        class="auth-emobile-cn"
      >
        <input
          v-model="emobileNum"
          :class="['emobile-cn', emobileCnTip.length ? 'onError' : '']"
          type="text"
          autocomplete="off"
          :placeholder="$t('请输入邮箱或手机号')"
          onpaste="return false"
          @keydown="addByEnterKey"
          @blur="verifyEmailMobile"
          @input="resetTip('emobile-cn')"
        >
      </div>
      <!--外国手机号-->
      <div
        v-else
        :class="['auth-mobile-int', emobileCnTip.length ? 'onError' : '']"
      >
        <bs-countryCode
          @pick="pickCountryCode"
          @codeChange="codeChange"
        />
        <input
          v-model="intMobile"
          class="mobile-int"
          type="text"
          autocomplete="off"
          :placeholder="$t('请输入手机号')"
          onpaste="return false"
          @keydown="addByEnterKey"
          @blur="verifyIntMobile()"
          @input="resetTip('emobile-int')"
        >
      </div>
      <!--验证码-->
      <div
        v-if="needCaptchaAuth"
        class="auth-captcha"
      >
        <input
          v-model="captchaNum"
          :class="['captcha-input', captchaTip.length ? 'onError' : '']"
          type="text"
          autocomplete="off"
          :placeholder="$t('请输入验证码')"
          onpaste="return false"
          :disabled="inputDisabled"
          @keydown="addByEnterKey"
          @input="resetTip('captcha')"
        >
        <div
          ref="getCaptcha"
          :class="['captcha-button', (!isShowInt && !emobileNum.length) || (isShowInt && !intMobile.length)? 'cap-disabled':'']"
          @click="captchaProcess"
        >
          {{ $t(captchaButTxt) }}
        </div>
      </div>
      <!--错误提示-->
      <div
        v-if="captchaTip || emobileCnTip"
        class="auth-tip"
      >
        {{ $t(emobileCnTip) || $t(captchaTip) }}
      </div>
      <div
        v-else
        :class="['auth-tip', sucCaptchaIcon? 'success-tip':'']"
      >
        <svg
          v-show="sucCaptchaIcon"
          class="icon-img"
        >
          <use xlink:href="#success" />
        </svg>
        {{ $t(getCaptchaTip) }}
      </div>
    </div>
    <div class="auth-footer">
      <div
        :class="['auth-button', needDisable?'disabled':'']"
        @click="submitAuth"
      >
        {{ $t(submitTxt) }}
      </div>
      <div
        class="switch-auth"
        @click="switchAuth"
      >
        {{ isShowInt ? $t('邮箱或国内手机号验证'):$t('国际手机号验证') }}
        <svg class="icon-img">
          <use xlink:href="#nextOne" />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { getCaptcha } from 'js/api/getCaptcha.js'
import { validEmail, validPhone } from 'js/util/util.js'
import bsCountryCode from 'components/business/link/countryCode/index.vue'

const { postData } = require('js/api/getdata').default

export default {
  components: {
    bsCountryCode,
  },
  mixins: [getCaptcha],
  props: {
    /**
         * 链接的相关信息
         */
    shareInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      emobileNum: '', // email or mobile num
      captchaNum: '', // captcha
      intMobile: '', // 国际手机号
      countryCode: '86', // 区号
      isShowInt: false, // 是否显示国际手机号验证
      captchaButTxt: '获取验证码', // 获取验证码的button文字
      submitTxt: '提交', // 提交按钮状态
      emobileCnTip: '', // email&mobile 错误提示信息
      captchaTip: '', // 验证码相关的错误提示信息
      sucCaptchaIcon: false, // 是否提示语前带提示icon，这里为正确的绿色icon
    }
  },
  computed: {
    /**
         * 是否需要出验证码
         */
    needCaptchaAuth() {
      if (this.shareInfo.receiver_setting == 2) return true
      return false
    },
    /**
         * 是否提交按钮要disabled
         */
    needDisable() {
      // 需验证码验证
      if (this.needCaptchaAuth) {
        // 国际验证时，国际手机号和验证码 不为空
        if (this.isShowInt && (!this.intMobile.length || !this.captchaNum.length)) {
          return true
        }
        // 国内验证时，mobile/emial 和验证码 不为空
        if (!this.isShowInt && (!this.emobileNum.length || !this.captchaNum.length)) {
          return true
        }
      }
      // 国际手机号
      if (this.isShowInt && !this.intMobile.length) {
        return true
      }
      // 国内手机号或邮箱
      if (!this.isShowInt && !this.emobileNum.length) {
        return true
      }
    },
    /**
         * 获取头像标识
         */
    getAvatorName() {
      const linkInfo = this.shareInfo.linkInfo || {}
      if (linkInfo.user_name) {
        return linkInfo.user_name && linkInfo.user_name.substr(0, 1)
      }
    },
  },
  methods: {
    /**
         * 重置提示语
         */
    resetTip(key) {
      this.sucCaptchaIcon = false
      this.getCaptchaTip = ''
      if (key === 'emobile-cn') {
        this.emobileCnTip = ''
        this.captchaPatten = ''
        this.inputDisabled = false
      } else if (key === 'emobile-int') {
        this.emobileCnTip = ''
        this.captchaPatten = ''
        this.inputDisabled = false
      } else if (key === 'captcha') {
        this.captchaTip = ''
      } else {
        this.emobileCnTip = ''
        this.captchaTip = ''
      }
    },
    /**
         * 改变country code
         */
    codeChange(code = '86') {
      this.emobileCnTip = '' // 清空手机号错误提示
      this.countryCode = code
    },
    /**
         * check mobile and email
         */
    verifyEmailMobile() {
      if (!validEmail(this.emobileNum.trim()) && !validPhone(this.emobileNum.trim())) {
        this.emobileCnTip = '请输入正确的邮箱或手机号格式'
        return
      }
      this.emobileCnTip = ''
      return true
    },
    /**
         * 点击country code
         */
    pickCountryCode() {
      this.emobileCnTip = '' // 清空手机号错误提示
    },
    /**
         * verify international mobile
         */
    verifyIntMobile(mobile) {
      const val = mobile || this.intMobile
      const res = /^\d{8,11}$/.test(val)
      if (!res) {
        this.emobileCnTip = '请输入正确的手机号格式'
        return
      }
      this.emobileCnTip = ''
      return true
    },
    /**
         * 建议验证码是否为空，为空返回false，否返回true
         */
    checkCaptcha() {
      if (!this.needCaptchaAuth) return true
      if (this.captchaNum.toString().length) {
        return true
      }
      return false
    },
    /**
         * 提交验证信息
         */
    submitAuth() {
      // 验证email/mobile是否为空
      if (!this.isShowInt && !this.emobileNum.toString().length) return
      if (this.isShowInt && !this.intMobile.toString().length) return
      // 如果有captcha，验证其是否为空
      if (this.needCaptchaAuth && !this.checkCaptcha()) return
      // 验证emial和手机号填写是否正确
      if (!this.isShowInt && !this.verifyEmailMobile()) return
      if (this.isShowInt && !this.verifyIntMobile()) return
      const params = {
        sToken: this.shareInfo.sToken,
        bindId: this.shareInfo._id,
        checkString: this.isShowInt ? `+${this.countryCode}-${this.intMobile}` : this.emobileNum,
        captcha: this.captchaNum,
      }
      if (!this.needCaptchaAuth) {
        delete params.captcha
      }
      this.checkAuth(params)
    },
    /**
         * 请求验证过程
         */
    checkAuth(params) {
      postData('checkSmCaptcha', params).then((res) => {
        const data = res.data && res.data.data || {}
        const token = data && data.sToken
        this.$emit('getSmToken', { token, emobileNum: this.emobileNum })
      }).catch((err) => {
        if (err.response && err.response.data) {
          let errTip = err.response.data.message || err.response.data.msg
          if (errTip === 'captcah error') {
            errTip = '验证码不正确，请重新输入'
          }
          this.captchaTip = errTip
        }
      })
    },
    /**
         * 获取验证码过程
         * 引入Captcha实例，里面完成了发送验证码，展示提示信息等相关逻辑
         */
    captchaProcess() {
      this.resetTip('captcha') // 清空验证码的错误提示
      if (this.emobileNum.length || this.intMobile.length) { // 前置条件，没有填写手机号或email时，不可以获取验证码
        const authData = { // 发送验证码所需的参数
          sToken: this.shareInfo.sToken,
          bindId: this.shareInfo._id,
          checkString: this.isShowInt ? `+${this.countryCode}-${this.intMobile}` : this.emobileNum,
        }
        if (this.isShowInt) {
          this.getCaptcha(this.intMobile, this.countryCode, authData, this.verifyIntMobile)
        } else {
          this.getCaptcha(this.emobileNum, '86', authData)
        }
      }
    },
    /**
         * 重新初始化数据
         */
    initData() {
      [this.emobileNum, this.captchaNum, this.intMobile] = ['', '', ''];
      [this.emobileCnTip, this.captchaTip, this.sucCaptchaIcon] = ['', '', '']
      this.captchaButTxt = '获取验证码'
      this.submitTxt = '提交'
      this.sucCaptchaIcon = false
      this.inputDisabled = false
      this.captchaPatten = ''
      this.getCaptchaTip = ''
      this.countryCode = '86' // 默认区号
    },
    /**
         * 切换验证方式
         */
    switchAuth() {
      this.isShowInt = !this.isShowInt
      this.stopProcess() // 这个方法在getCaptcha.js中，切换验证方式时，用于停止验证码的倒计时
      this.initData()
    },
    /**
         * enter事件
         */
    addByEnterKey(e) {
      if (e.keyCode == 13) {
        this.submitAuth()
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/auth.less';
.auth-wrapper{
  width: 404px;
  height: auto;
  padding: 41px 52px 25px 52px;
  position: absolute;
  top: calc(50% - 50px);
  left: 50%;
  transform: translateY(-50%);
  margin-left: -202px;
  .icon-img{
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
  .auth-body{
    .auth-tip {
      margin: 16px 0 0 0;
      font-size: 12px;
      color: #FF3D3C;
    }
    .success-tip{
      color: #4C5365;
    }
  }
  .auth-footer{
    margin: 30px 0 0 0;
  }
  // 改变input的disabled
  input:disabled {
    color: #C6CDD7;
    cursor: default;
    background-color: #F8F8F8;
    border: 1px solid #C6CDD7 !important;
  }
}
// 发送中...
.disable-captcha {
  .auth-body{
    .auth-captcha{
      .captcha-button {
        color: #C6CDD7;
        background: #F8F8F8;
        border: 1px solid #C6CDD7;
        cursor: default;
      }
    }
  }
}
</style>
